import { useEffect, useState } from "react";
import api from "../services/api";
import { auth } from "../firebase";

export function useBankLinkStatus(reference, enabled = true) {
  const [isLoading, setIsLoading] = useState(true);
  const [status, setStatus] = useState("pending"); // "pending", "connected", "failed"
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!reference || !enabled) return;

    let interval;
    let attempts = 0;
    const maxAttempts = 10;

    const checkStatus = async () => {
      try {
        const token = await auth.currentUser.getIdToken();
        const res = await api.get(`/bank/status/ref/${reference}`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (res.data.connected) {
          setStatus("connected");

          console.log("✅ Poll success — calling /confirm-connected with:", {
            requisitionId: res.data.requisitionId,
            institutionId: res.data.institutionId,
            institutionName: res.data.institutionName,
            accountIds: res.data.accountIds,
          });

          // Confirm on backend
          const confirmRes = await api.put(
            "/bank/confirm-connected",
            {
              requisitionId: res.data.requisitionId,
              institutionId: res.data.institutionId,
              institutionName: res.data.institutionName,
              accountIds: res.data.accountIds,
            },
            { headers: { Authorization: `Bearer ${token}` } }
          );

          console.log("✅ Bank connection confirmed:", confirmRes.data);

          clearInterval(interval);
          setIsLoading(false);
        } else {
          setStatus("pending");
        }
      } catch (err) {
        if (err.response?.status !== 202) {
          console.error("❌ Bank status polling error:", err);
          setError("Failed to check status.");
          setStatus("failed");
          clearInterval(interval);
          setIsLoading(false);
        }
      }

      attempts++;
      if (attempts >= maxAttempts) {
        setStatus("failed");
        setError("Timeout waiting for bank connection.");
        setIsLoading(false);
        clearInterval(interval);
      }
    };

    interval = setInterval(checkStatus, 3000);
    checkStatus(); // Run immediately

    return () => clearInterval(interval);
  }, [reference, enabled]);

  return { status, isLoading, error };
}
